import { Toaster } from 'sonner';
import { useTheme } from './ThemeProvider';

export const CustomToaster = () => {
  const { theme } = useTheme();
  return (
    <Toaster
      theme={['dark', 'blue'].includes(theme) ? 'dark' : 'light'}
      richColors
      position="bottom-center"
      className="!bg-secondary"
    />
  );
};
